import { DateTime } from 'luxon';

export const parseUTCDateTime = (date: string, time: string): Date => {
  const dateFormatted = DateTime.fromISO(date).toUTC().toFormat('yyyy-MM-dd');
  const timeFormatted = DateTime.fromFormat(time, 'HH:mm').toUTC().toFormat('HH:mm');
  return new Date(`${dateFormatted}T${timeFormatted}:00.000Z`);
};
